import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowUpRightFromSquare, faListCheck, faLightbulb } from '@fortawesome/free-solid-svg-icons';
import Button from "~/ui-apps/design-system/atoms/Button";

export interface EvaluationEmptyStateProps {
  isMobileDevice: boolean;
  onBrowseTemplates: () => void;
  onCreateYourOwn: React.MouseEventHandler<HTMLButtonElement>;
}

const EvaluationEmptyState: React.FC<EvaluationEmptyStateProps> = ({
  isMobileDevice,
  onBrowseTemplates,
  onCreateYourOwn,
}) => (
  <div className="text-center mt-16 md:mt-16">
  <div className="max-w-2xl mx-auto px-4">
    {/* Icon and Header */}
    <div className="mb-6 animate-fade-in">
      <div className="inline-flex items-center justify-center w-16 h-16 md:w-20 md:h-20 rounded-full bg-gradient-to-br from-green-100 to-green-50 border-2 border-green-200 mb-4">
        <FontAwesomeIcon icon={faListCheck} className="text-3xl text-green-600" />
      </div>
      <h2 className="text-xl md:text-3xl font-bold text-gray-900 mb-2.5">
        Create Your Evaluation Criteria
      </h2>
      <p className="text-gray-500 text-sm md:text-base mb-8">
        Start with templates or create your own
      </p>
    </div>

    {/* CTA Buttons */}
    <div className="flex flex-col sm:flex-row gap-4 justify-center items-center animate-fade-in">
    <Button
        type="outline"
        size={isMobileDevice ? 'xs' : 'small'}
        onClick={onBrowseTemplates}
        iconPosition="right"
        icon={<FontAwesomeIcon icon={faArrowUpRightFromSquare} className="w-4 h-4" />}
        className="w-auto px-6 py-2.5"
      >
        Browse Templates
      </Button>
      <Button
        type="primary"
        size={isMobileDevice ? 'xs' : 'small'}
        onClick={onCreateYourOwn}
        className="w-auto px-6 py-2.5 shadow-lg hover:shadow-xl transition-shadow"
        icon={<FontAwesomeIcon icon={faLightbulb} className="w-4 h-4 text-yellow-500" />}
        iconPosition="left"
      >
        Create Your Own
      </Button>
    </div>

    {/* Helper Text */}
    <p className="mt-6 text-gray-400 text-xs md:text-sm">
      💡 Tip: Start with 3-5 criteria to build a focused evaluation framework
    </p>
  </div>
</div>
);

export default EvaluationEmptyState;
